import { render, staticRenderFns } from "./DistributorsForm.vue?vue&type=template&id=dab97e2c"
import script from "./DistributorsForm.vue?vue&type=script&lang=js"
export * from "./DistributorsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports